export default __webpack_public_path__ + "static/media/explore-img.28d83c24.png";